webpackJsonp([70144966829960],{

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styled = __webpack_require__(18);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _styles = __webpack_require__(33);
	
	var _core = __webpack_require__(17);
	
	var _reactMarkdown = __webpack_require__(22);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Caption = (0, _styled2.default)(_core.Typography, { variant: 'caption' })(function (theme) {
	  var _ref;
	
	  return _ref = {
	    display: 'block',
	    lineHeight: '80px'
	  }, _ref[theme.breakpoints.down('sm')] = {
	    lineHeight: '40px'
	  }, _ref;
	});
	
	var styles = function styles(theme) {
	  return {
	    container: {
	      display: 'flex',
	      flexWrap: 'wrap'
	    },
	    textField: {
	      marginLeft: theme.spacing.unit,
	      marginRight: theme.spacing.unit
	      //width: 200,
	    }
	  };
	};
	
	function ContactForm(props) {
	  var _React$createElement, _React$createElement2, _React$createElement3, _React$createElement4, _React$createElement5, _React$createElement6, _React$createElement7, _React$createElement8, _React$createElement9, _React$createElement10;
	
	  var classes = props.classes;
	
	  var data = props.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _core.Typography,
	      { variant: 'headline', component: 'h3' },
	      'Kirjuta meile:'
	    ),
	    _react2.default.createElement(
	      'form',
	      {
	        action: 'https://formspree.io/seiklus@seikluseksperdid.ee',
	        method: 'POST' },
	      _react2.default.createElement(
	        _core.Grid,
	        { container: true },
	        _react2.default.createElement(
	          _core.Grid,
	          (_React$createElement = { item: true }, _React$createElement['item'] = true, _React$createElement.xs = 3, _React$createElement),
	          _react2.default.createElement(_core.TextField, {
	            id: 'name',
	            name: 'name',
	            label: 'Nimi',
	            className: classes.textField,
	            margin: 'normal'
	          })
	        ),
	        _react2.default.createElement(_core.Grid, (_React$createElement2 = { item: true }, _React$createElement2['item'] = true, _React$createElement2.xs = 3, _React$createElement2)),
	        _react2.default.createElement(_core.Grid, (_React$createElement3 = { item: true }, _React$createElement3['item'] = true, _React$createElement3.xs = 3, _React$createElement3)),
	        _react2.default.createElement(_core.Grid, (_React$createElement4 = { item: true }, _React$createElement4['item'] = true, _React$createElement4.xs = 3, _React$createElement4)),
	        _react2.default.createElement(
	          _core.Grid,
	          (_React$createElement5 = { item: true }, _React$createElement5['item'] = true, _React$createElement5.xs = 3, _React$createElement5),
	          _react2.default.createElement(_core.TextField, {
	            id: 'email',
	            type: 'email',
	            name: '_replyto',
	            label: 'E-post',
	            className: classes.textField,
	            margin: 'normal'
	          })
	        ),
	        _react2.default.createElement(_core.Grid, (_React$createElement6 = { item: true }, _React$createElement6['item'] = true, _React$createElement6.xs = 3, _React$createElement6)),
	        _react2.default.createElement(_core.Grid, (_React$createElement7 = { item: true }, _React$createElement7['item'] = true, _React$createElement7.xs = 3, _React$createElement7)),
	        _react2.default.createElement(_core.Grid, (_React$createElement8 = { item: true }, _React$createElement8['item'] = true, _React$createElement8.xs = 3, _React$createElement8)),
	        _react2.default.createElement(
	          _core.Grid,
	          (_React$createElement9 = { item: true }, _React$createElement9['item'] = true, _React$createElement9.xs = 6, _React$createElement9),
	          _react2.default.createElement(_core.TextField, {
	            multiline: true,
	            fullWidth: true,
	            rows: '4',
	            id: 'text',
	            name: 'text',
	            label: 'S\xF5num',
	            className: classes.textField,
	            margin: 'normal',
	            InputProps: { fullWidth: true } })
	        ),
	        _react2.default.createElement(
	          _core.Grid,
	          (_React$createElement10 = { item: true }, _React$createElement10['item'] = true, _React$createElement10.xs = 12, _React$createElement10),
	          _react2.default.createElement('input', { type: 'hidden', name: '_next', value: 'https://www.seikluseksperdid.ee/contactsent' }),
	          _react2.default.createElement(
	            _core.Button,
	            { type: 'submit' },
	            'Saada'
	          )
	        )
	      )
	    )
	  );
	}
	
	ContactForm.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styles.withStyles)(styles)(ContactForm);
	module.exports = exports['default'];

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMarkdown = __webpack_require__(22);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styled = __webpack_require__(18);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _core = __webpack_require__(17);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ContactForm = __webpack_require__(437);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var content = '\nSeikluseksperdid O\xDC  \nTihasheina tee 9  \n74117 Maardu\nEesti\n\nRegistrikood: 14503058  \nE-post: seikluseksperdid@gmail.com    \nTelefon: +372 52 75 333\n';
	
	var Contact = function Contact(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, xs: 12, sm: 8 },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Kontakt' }),
	      _react2.default.createElement(
	        _core.Typography,
	        { variant: 'display1' },
	        'Kontakt'
	      ),
	      _react2.default.createElement(_core.Typography, { component: _reactMarkdown2.default, source: content, escapeHtml: false }),
	      _react2.default.createElement(_ContactForm2.default, null)
	    )
	  );
	};
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-e367476bd8f4be682b65.js